// First-touch UTM attribution.
//
// Reads utm_* params from the URL on any landing and stores them in
// localStorage. Once stored, the entry is NOT overwritten by later visits
// with different UTMs — the first touch wins, which is the right model for
// acquisition attribution (gives credit to the channel that introduced the
// user, not to whatever banner they clicked last).
//
// Consumers: register flows (email + Google) read getAttributionPayload()
// and forward signup_source / signup_campaign to the backend, which stores
// them on HolUser and pushes SOURCE/CAMPAIGN attrs to Brevo.

const STORAGE_KEY = 'holistiqum_utm_attribution';

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

function hasLocalStorage() {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}

export function captureUtmFromSearch(searchString) {
  if (!hasLocalStorage()) return;
  if (window.localStorage.getItem(STORAGE_KEY)) return; // first-touch wins

  const params = new URLSearchParams(searchString || '');
  const captured = {};
  UTM_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value) captured[key] = value;
  });

  if (Object.keys(captured).length === 0) return;

  captured.captured_at = new Date().toISOString();
  captured.landing_path = window.location.pathname || '';
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(captured));
}

export function getAttribution() {
  if (!hasLocalStorage()) return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

// Subset suitable for /user/register/ and /user/google_login/ payloads.
// Maps utm_source → signup_source and utm_campaign → signup_campaign,
// truncated to match HolUser field max_length (32 / 64). Empty object if
// no attribution stored yet — caller can spread it unconditionally.
export function getAttributionPayload() {
  const attr = getAttribution();
  if (!attr) return {};
  const payload = {};
  if (attr.utm_source) payload.signup_source = String(attr.utm_source).slice(0, 32);
  if (attr.utm_campaign) payload.signup_campaign = String(attr.utm_campaign).slice(0, 64);
  return payload;
}

export function clearAttribution() {
  if (!hasLocalStorage()) return;
  window.localStorage.removeItem(STORAGE_KEY);
}
